import { isDataTransferSupported } from '@tesla/design-system';
import React from 'react';
import { List } from '../list/index.js';
import { FileListItem } from './file-list-item.js';
/**
 * A formatted tds-list with a button that allows a file to be removed from a file upload list
 */
export const FormInputFilesList = ({ fileNames, onRemove }) => {
    return (React.createElement("div", { className: "tds-form-label tds-form-label-files" },
        React.createElement(List, null, fileNames.map((name) => (React.createElement(FileListItem, { canRemove: isDataTransferSupported(), key: name, name: name, onRemove: onRemove }))))));
};
